import { render, staticRenderFns } from "./cupProduction.vue?vue&type=template&id=206eb464&scoped=true&"
import script from "./cupProduction.vue?vue&type=script&lang=js&"
export * from "./cupProduction.vue?vue&type=script&lang=js&"
import style0 from "./cupProduction.vue?vue&type=style&index=0&id=206eb464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206eb464",
  null
  
)

export default component.exports